import React from 'react';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';
import styles from './Help.module.scss';

const Help = () => {
  const { t } = useTranslation();
  const termsUrl = useSelector(getConfigurationByKey('termsUrl'));
  const customerCareUrl = useSelector(getConfigurationByKey('customerCareUrl'));

  const redirectToTerms = () => {
    window.open(termsUrl, '_blank');
  };

  const redirectToCustomerCare = () => {
    window.open(customerCareUrl, '_blank');
  };

  return (
    <div className={styles.help}>
      <div className={styles.helpLink} onClick={redirectToCustomerCare}>
        <OpIcon icon="help" size="small" />
        <OpText variant="title-small-regular">{t('txt_plus_faq')}</OpText>
      </div>
      <div className={styles.helpLink} onClick={redirectToTerms}>
        <OpIcon icon="document" size="small" />
        <OpText variant="title-small-regular">{t('txt_plus_terms')}</OpText>
      </div>
    </div>
  );
};

export default Help;
